const header = document.querySelector('[data-site-header]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');
const storeRoot = window.Shopify?.routes?.root || '/';

if (header && menuToggle && mobileNav) {
  const setMenu = (open) => {
    header.classList.toggle('is-menu-open', open);
    document.body.classList.toggle('has-mobile-nav', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menuToggle.querySelector('.menu-glyph')?.classList.toggle('is-open', open);
    mobileNav.hidden = !open;
    if (open) mobileNav.querySelector('a')?.focus();
  };

  menuToggle.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
  mobileNav.addEventListener('click', (event) => {
    if (event.target.closest('a')) setMenu(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || menuToggle.getAttribute('aria-expanded') !== 'true') return;
    setMenu(false);
    menuToggle.focus();
  });
}

document.addEventListener('click', (event) => {
  const cartToggle = event.target.closest('[data-cart-toggle]');
  if (cartToggle && document.body.dataset.cartDrawerEnabled === 'true') {
    event.preventDefault();
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.hidden = false;
      document.body.classList.add('has-cart-drawer');
      drawer.querySelector('[data-cart-close]')?.focus();
    }
  }

  if (event.target.closest('[data-cart-close]')) {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) drawer.hidden = true;
    document.body.classList.remove('has-cart-drawer');
    document.querySelector('[data-cart-toggle]')?.focus();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !document.body.classList.contains('has-cart-drawer')) return;
  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) drawer.hidden = true;
  document.body.classList.remove('has-cart-drawer');
  document.querySelector('[data-cart-toggle]')?.focus();
});

document.querySelector('[data-gift-wrap-variant]')?.addEventListener('change', async (event) => {
  const variantId = Number(event.target.dataset.giftWrapVariant);
  const cartResponse = await fetch(`${storeRoot}cart.js`);
  if (!cartResponse.ok) return;
  const cart = await cartResponse.json();
  const giftItem = cart.items.find((item) => item.variant_id === variantId);
  const endpoint = event.target.checked ? `${storeRoot}cart/add.js` : `${storeRoot}cart/change.js`;
  const payload = event.target.checked ? { items: [{ id: variantId, quantity: 1 }] } : { id: giftItem?.key, quantity: 0 };
  if (!event.target.checked && !giftItem) return;
  await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
  window.location.reload();
});

if (document.body.dataset.revealAnimation === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('main > section:not(:first-child)').forEach((section) => {
    section.classList.add('will-reveal');
    observer.observe(section);
  });
}

document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
  const slides = [...slideshow.querySelectorAll('[data-slide]')];
  let activeIndex = 0;
  const show = (index) => {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
  };
  slideshow.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(activeIndex - 1));
  slideshow.querySelector('[data-slide-next]')?.addEventListener('click', () => show(activeIndex + 1));
});
